import store from '../store';

// Account stuff
export const ADMIN_PREFIX = '/account';

/**
 * Navigate to given path
 */
export function navigateTo(path, usePushState = true) {
  let normalizedRoute = normalizeUrl(path);
  let pathUrl = '/' + normalizedRoute;

  // Don't hijack links that are not part of the SPA admin area
  if (!path.startsWith(ADMIN_PREFIX)) {
    window.location = pathUrl;
    return false;
  }

  // Set route to trigger update
  store.set('ui.route', {
    path: normalizedRoute || '/',
    params: {},
  });

  if (usePushState) {
    history.pushState(null, document.title, pathUrl);
  }

  updateRouteHistory(normalizedRoute);
}


/**
 * Normalize URL (remove leading and trailing slashes)
 * @param {String} url
 * @return {String}
 */
export function normalizeUrl(url) {
  if (url.startsWith('/')) {
    url = url.substr(1);
  }

  if (url.endsWith('/')) {
    url = url.substring(0, url.length - 1);
  }

  return url;
}

export function updateRouteHistory(nextRoute) {
  const routeHistory = store.get('ui.routeHistory').map(normalizeUrl);

  if (nextRoute) {
    // Back to previous route if nextRoute was most recent in stack (besides current one)
    if (routeHistory.reverse().indexOf(nextRoute) === 1) {
      routeHistory.pop();
    } else {
      // Add new route as next one
      routeHistory.push(nextRoute);
    }
  } else {
    routeHistory.pop();
  }

  store.set('ui.routeHistory', routeHistory);
}
